import {
  getItemLocalStorage,
  removeItemLocalStorage,
  setItemLocalStorage
} from '../../../utils/toBeRemoved/localStorage';
import * as T from '../types';
import { container } from 'tsyringe';

export const jshellLoggerPropsLocalStorageKey = 'jshellLoggerProps';

// TODO:In the future, this need to be changed to a Repository
export const _getLoggerOptions = (): T.LoggerInputType => {
  // Define sensible defaults for early initialization phases
  const fallbackDefaults: T.LoggerInputType = {
    enable: true,
    enableDecorators: true,
    allowedTypes: {
      debug: true,
      error: true,
      log: true,
      warn: true
    }
  };

  // Try to resolve LoggerProps from DI container, but gracefully handle if not available yet
  let manifestLoggerInput: T.LoggerInputType | undefined;
  try {
    manifestLoggerInput = container?.resolve<T.LoggerInputType>('LoggerProps');
  } catch (error) {
    // LoggerProps not registered yet (early initialization phase)
    // This is expected during early app lifecycle before initializeCommons() runs
    manifestLoggerInput = undefined;
  }

  // Priority order: localStorage > DI container > fallback defaults
  const loggerProps: T.LoggerInputType =
    getItemLocalStorage(jshellLoggerPropsLocalStorageKey) ||
    manifestLoggerInput ||
    fallbackDefaults;

  return {
    ...loggerProps,
    enable: loggerProps?.enable ?? true,
    enableDecorators: loggerProps?.enableDecorators ?? true,
    allowedTypes: {
      ...loggerProps?.allowedTypes,
      error: loggerProps?.allowedTypes?.error ?? true
    }
  };
};

export const _setLocalOptions: T.SetLocalOptionsType = (options) => {
  const fixedOptions = {
    ...options,
    allowedTypes: {
      debug: false,
      error: false,
      log: false,
      warn: false,
      ...options?.allowedTypes
    }
  };
  setItemLocalStorage(jshellLoggerPropsLocalStorageKey, fixedOptions);
};

export const _removeLocalOptions: T.RemoveLocalOptionsType = () => {
  removeItemLocalStorage(jshellLoggerPropsLocalStorageKey);
};
